<template>
  <v-card class="px-3" :loading="loading">
    <v-card-text>
      <v-layout wrap row align-center>
        <v-flex xs12 md8 px-1 v-if="resourceSettings.search">
          <v-text-field
              label="Search"
              outline
              hide-details
              :append-icon="`${search? 'close':''}`"
              @click:append="()=>{search=null;loadResource();}"
              dense
              :loading="loading"
              :name="search"
              @keyup="searchResource()"
              @keypress.enter="searchResource()"
              v-model.lazy="search"
            ></v-text-field>
        </v-flex>
        <v-flex xs12 md4 px-1 v-if="resourceSettings.create">
          <v-btn large color="primary" @click="create()" :loading="loading" block>
            create new
          </v-btn>
        </v-flex>
        <v-flex xs12 md2 px-1 v-if="resourceSettings.create">
          <v-btn large color="primary" @click="viewCategories()" :loading="loading" block>
            categories
          </v-btn>
        </v-flex>
        <v-flex xs12 md4 px-1 v-if="resourceSettings.create">
          <v-btn large color="primary" @click="createCategory()" :loading="loading" block>
            create a new category
          </v-btn>
        </v-flex>
        <v-flex xs12 md12 px-1 pt-3 style="font-weight:bold;font-size:11px;">
          LOADED IN {{time}}s
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      search:null
    }
  },
  props:['loading', 'resourceSettings', 'time'],
  methods:{
    viewCategories() {
      this.$emit('viewCategories')
    },
    searchResource() {
      if( this.search && this.search.length > 2 )
      this.$emit('searchResource', this.search)
    },
    loadResource() {
      this.$emit('loadResource')
    },
    create() {
      this.$emit('create')
    },
    createCategory() {
      this.$emit('createCategory')
    }
  },
  computed:{
    
  }
}
</script>

<style>

</style>